import * as React from 'react';
export const InteractionTagContext = /*#__PURE__*/ React.createContext(undefined);
const interactionTagContextDefaultValue = {
    appearance: 'filled',
    disabled: false,
    handleTagDismiss: ()=>null,
    shape: 'rounded',
    size: 'medium',
    value: ''
};
export const InteractionTagContextProvider = InteractionTagContext.Provider;
var _React_useContext;
export const useInteractionTagContext_unstable = ()=>(_React_useContext = React.useContext(InteractionTagContext)) !== null && _React_useContext !== void 0 ? _React_useContext : interactionTagContextDefaultValue;
